import { render } from "./UserProfile.vue?vue&type=template&id=a87c011a"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src676743866/src/profileSite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__